<template>
  <div>
    <section2-a class="mb-3"
                :$v="$v"
    ></section2-a>
    <section2-b class="mb-3"
                :$v="$v"
    ></section2-b>
    <section2-c class="mb-3"
                :$v="$v"
    ></section2-c>
    <section2-d class="mb-3"
                :$v="$v"
    ></section2-d>
  </div>
  
</template>

<script>
  import { mapActions, mapMutations } from 'vuex'

  import { validationMixin } from 'vuelidate';

  import { mapFields } from 'vuex-map-fields';
  import { required, minValue, between } from 'vuelidate/lib/validators'
  import { checkLastKnownTreatment } from './../../../js/validation/lastKnownTreatment.js'

  import Section2A from './Section2A'
  import Section2B from './Section2B'
  import Section2C from './Section2C'
  import Section2D from './Section2D'


  const currYear = () => {
    const d = new Date();
    return d.getFullYear()
  };


  export default {
    name: "Section2",
    components:{
      Section2A,
      Section2B,
      Section2C,
      Section2D
    },
    mixins: [
      validationMixin
    ],
    computed: {
      ...mapFields('rx',[
          //2a
          "currentProject.pavementType",
          "currentProject.segmentLengthFt",
          "currentProject.segmentWidthFt",
          "currentProject.intersectionPresent",
          "currentProject.twoWayTurnPresent",
          //2b
          "currentProject.lastPCRYear",
          "currentProject.lastPCRReading",
          "currentProject.lastTreatmentYear",
          "currentProject.lastKnownTreatment",
          //2c
          "currentProject.hasParkingLanes",
          "currentProject.hasParkingLanesDescription",
          "currentProject.hasShoulder",
          "currentProject.hasShoulderDescription",
          "currentProject.hasBikeLane",
          "currentProject.hasBikeLaneDescription",
          "currentProject.hasCurb",
          "currentProject.hasCurbDescription",
          "currentProject.hasOtherSurface",
          "currentProject.hasOtherSurfaceDescription",
          //2d
          "currentProject.hasConcreteLayers",
          "currentProject.hasConcreteLayersDescription",
          "currentProject.hasTreatedBase",
          "currentProject.hasTreatedBaseDescription",
          "currentProject.hasShallowUtilities",
          "currentProject.hasShallowUtilitiesDescription",
          "currentProject.hasGeotextiles",
          "currentProject.hasGeotextilesDescription",
          "currentProject.hasOtherSubsurface",
          "currentProject.hasOtherSubsurfaceDescription",
        ]
      )
    },
    methods: {
      ...mapActions('rx',[
        'validateProjectState',
      ]),
      ...mapMutations('rx',[
        'setPageValidationState'
      ]),
      validateLastKnownTreatment: function(){
        const age = currYear() - this.lastTreatmentYear;
        return checkLastKnownTreatment(this.lastKnownTreatment, age);
      },
    },
    beforeMount(){
      this.validateProjectState();
      this.setPageValidationState(this.$v);
    },
    mounted(){
    },
    validations:{
      /*
      Validations are setup here so that the validator object can be passed to the store for
      save-button/save-status tracking and also passed down to the child components so that
      primary validation occurs in the form itself.
       */
      //2a
      pavementType:{
        required
      },
      segmentLengthFt:{
        required,
        minValue: minValue(0)
      },
      segmentWidthFt:{
        required,
        minValue: minValue(0)
      },
      intersectionPresent: {
        required
      },
      twoWayTurnPresent:{
        required
      },

      //2b
      lastPCRYear:{
        required,
        between: between(1900, currYear())
      },
      lastPCRReading: {
        required,
        between: between(0, 100)
      },
      lastTreatmentYear: {
        required,
        between: between(1900, currYear())
      },
      lastKnownTreatment:{
        required
      },

      //2c
      hasParkingLanes: {
        required
      },
      hasShoulder: {
        required
      },
      hasBikeLane: {
        required
      },
      hasCurb: {
        required
      },
      hasOtherSurface: {
        required
      },

      //2d
      hasConcreteLayers: {
        required
      },
      hasTreatedBase: {
        required
      },
      hasShallowUtilities: {
        required
      },
      hasGeotextiles:{
        required
      },
      hasOtherSubsurface: {
        required
      }
    }
  }
</script>

<style scoped>

</style>